"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailTo = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
function MailTo({ text, email, linkClassNames = 'underline', textClassNames = 'text-blue-900 inline', textStyle = {}, inline = true, variant = 'subtitle1', }) {
    return (react_1.default.createElement(core_1.Link, { href: `mailto:${email}`, className: linkClassNames },
        react_1.default.createElement(core_1.Typography, { variant: variant, className: textClassNames, style: { display: 'inline', ...textStyle } }, text || email)));
}
exports.MailTo = MailTo;
